import { api, apiStore } from '@sh/services/api';

const backendApi = {
  campaigns: {
    all(tsTypes) {
      return api.campaigns.all(tsTypes);
    },
    getByFilters(payload) {
      return api.campaigns.getByFilters(payload);
    },
  },
  rules: {
    async get(id) {
      const rules = await apiStore.rules.index();
      return rules.find(({ _id }) => _id === id);
    },
    groups() {
      return api.rules.groups();
    },
    tags() {
      return [];
    },
    update(id, rule) {
      return api.rules.update(id, rule);
    },
    create(rule) {
      return api.rules.create(rule);
    },
    templates() {
      return [];
      // return api.rules.templates({id})
    },
  },
  notification: {
    getSettings() {
      return api.notification.getSettings();
    },
  },
};

export { backendApi as api };
